@if (showModal()) {
  <div class="sx-update-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="sx-update-modal-title">
    <div class="sx-update-modal sx-card" (click)="$event.stopPropagation()">
      <div class="sx-update-modal__hero">
        <img
          class="sx-update-modal__logo"
          src="/brand/synexa-icon-192.png"
          width="56"
          height="56"
          alt="Synexa"
        />
        <p class="sx-update-modal__eyebrow">Synexa Health</p>
        <h2 id="sx-update-modal-title" class="sx-update-modal__title">Update available</h2>
        <p class="sx-update-modal__description">
          A new version of Synexa is ready. You are currently on
          <strong>v{{ currentVersion }}</strong>. Reload to apply the latest improvements, fixes, and
          security updates. Unsaved work on this page may be lost.
        </p>
      </div>

      <div class="sx-update-modal__shortcut" aria-label="Hard reload shortcut: Shift, Control, R">
        <div class="sx-update-modal__shortcut-icon" aria-hidden="true">
          <lucide-icon [img]="icons.refresh" class="h-5 w-5"></lucide-icon>
        </div>
        <p class="sx-update-modal__shortcut-label">Hard reload</p>
        <p class="sx-update-modal__shortcut-hint">Press each key — it turns green</p>
        <div class="sx-update-modal__shortcut-keys" aria-hidden="true">
          <kbd [class.is-active]="shiftPressed()">Shift</kbd>
          <span class="sx-update-modal__shortcut-plus">+</span>
          <kbd [class.is-active]="ctrlPressed()">Ctrl</kbd>
          <span class="sx-update-modal__shortcut-plus">+</span>
          <kbd [class.is-active]="rPressed()">R</kbd>
        </div>
      </div>

      <div class="sx-update-modal__footer">
        <button type="button" class="sx-update-modal__btn sx-update-modal__btn--secondary" (click)="dismiss()">
          Later
        </button>
        <button type="button" class="sx-update-modal__btn sx-update-modal__btn--primary" (click)="reload()">
          <lucide-icon [img]="icons.refresh" class="h-4 w-4"></lucide-icon>
          Reload now
        </button>
      </div>
    </div>
  </div>
}
